window._ = require('lodash');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

try {
     window.Popper = require('popper.js').default;
     window.$ = window.jQuery = require('jquery');

     require('bootstrap');
     require('jquery-smooth-scroll')
} catch (e) {}

// required for vue js release note modals
import Vue from 'vue'
window.Vue = Vue;

import VModal from 'vue-js-modal'
window.Vue.use(VModal, { dynamic: true, dynamicDefaults: { clickToClose: true } })

// Vuejs event bus to pass messages between components
Vue.prototype.$eventBus = new Vue();

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// use if enable-laravel-mix is set to true in adminlte.php
// require('overlayscrollbars');
// require('../../vendor/almasaeed2010/adminlte/dist/js/adminlte');

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}
